module.exports = __webpack_public_path__ + "img/banner.1f57e619.png";